import api from './utilBackoffice';

const controller = 'EnvioEmailServico';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto)
});
